import { DefaultInMemoryPagingOfferConfiguration } from './DefaultInMemoryPagingOfferConfiguration';
import { ILivePageableOfferConfiguration } from "./ILivePageableOfferConfiguration";

export class DefaultLivePageableConfiguration extends DefaultInMemoryPagingOfferConfiguration implements ILivePageableOfferConfiguration {
}